// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import PoliciesGuidelinesSafetyPage from "../pages/PoliciesGuidelinesSafety/PoliciesGuidelinesSafety";
const __wvcRoutePaths = ["/PoliciesGuidelinesSafetyPage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            
            
            
            
            
            
            
            <Route path={__wvcRoutePaths[0]} element={<PoliciesGuidelinesSafetyPage />} />
            
            
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
